// extracted by mini-css-extract-plugin
module.exports = {"title":"TestStatusTitle_title__zq6p0","subtitle":"TestStatusTitle_subtitle__VCA9X"};